import { render, staticRenderFns } from "./JackpotSetting.vue?vue&type=template&id=5fea9d83&"
import script from "./JackpotSetting.vue?vue&type=script&lang=js&"
export * from "./JackpotSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports